import { render } from "./ClubMemberGallery.vue?vue&type=template&id=84680a7a&scoped=true"
import script from "./ClubMemberGallery.vue?vue&type=script&lang=js"
export * from "./ClubMemberGallery.vue?vue&type=script&lang=js"

import "./ClubMemberGallery.vue?vue&type=style&index=0&id=84680a7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84680a7a"]])

export default __exports__